import fgInput from './components/UIComponents/Inputs/formGroupInput.vue'
import DropDown from './components/UIComponents/Dropdown.vue'
import Checkbox from './components/UIComponents/Inputs/Checkbox.vue'
import Radio from './components/UIComponents/Inputs/Radio.vue'
import EvaluationAnswer from './components/UIComponents/Inputs/EvaluationAnswer.vue'
import EvaluationDeliveryAnswer from './components/UIComponents/Inputs/EvaluationDeliveryAnswer.vue'
import LoadingSpin from './components/UIComponents/LoadingSpin.vue'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component(fgInput.name, fgInput)
    Vue.component(DropDown.name, DropDown)
    Vue.component(Checkbox.name, Checkbox)
    Vue.component(Radio.name, Radio)
    Vue.component(EvaluationAnswer.name, EvaluationAnswer)
    Vue.component(EvaluationDeliveryAnswer.name, EvaluationDeliveryAnswer)
    Vue.component('loading-spin', LoadingSpin)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/gloablComponents.js